import { Route } from "@angular/router";
import { MeuPerfilPage } from "./meu-perfil.page";

export const MeuPerfilRouter: Route[] = [
  { path: 'meu-perfil', component: MeuPerfilPage }
];
